import React from "react"
import { Box, CodeSnippet } from "dash-styled"
import { SimpleInfoBox } from "../../SimpleInfoBox/SimpleInfoBox"

export const Fallback = ({
    value,
    infoMessage,
    helpText
}: {
    value: unknown
    infoMessage?: string
    helpText?: string
}) => (
    <div style={{ overflow: "auto" }}>
        <Box paddingBottom="4" paddingTop="2">
            <CodeSnippet>{JSON.stringify(value, null, 2)}</CodeSnippet>
        </Box>
        <SimpleInfoBox variant="info" helpText={helpText}>
            {infoMessage ??
                "We are working on pretty-rendering this data type."}
        </SimpleInfoBox>
    </div>
)
